import { render, staticRenderFns } from "./FileUploadNode.vue?vue&type=template&id=4a563b91&scoped=true&"
import script from "./FileUploadNode.vue?vue&type=script&lang=js&"
export * from "./FileUploadNode.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadNode.vue?vue&type=style&index=0&id=4a563b91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a563b91",
  null
  
)

export default component.exports